module.exports = __webpack_public_path__ + "img/Commant.4c6b0fe4.png";